import EditTeamCategory from "./Edit";

export default function AddTeamCategory() {
    return <EditTeamCategory mode="add" />;
}
